package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.virtual_card

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.virtual_card.component.AppleWallet
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.virtual_card.component.DigitalCustomerCardInfo
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.virtual_card.component.GoogleWallet
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsState

@Composable
fun VirtualCard(
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum
)
{
    LaunchedEffect(Unit){
        event(OptionsEvent.GetVirtualCardInfo)
    }

    Column(
        modifier = Modifier
            .autoResponsiveness() 
            .fillMaxSize()
    )
    {

        if (windowSizeMode== WindowSizeModeEnum.Desktop)
        {
            Row(
                modifier = Modifier
                    .overflow(Overflow.Auto)
                    .fillMaxSize()
                    .borderSetting()
                    .borderRadius(Dimen.semiLargeRadius)
                    .padding(
                        bottom =  Dimen.extraLargePadding,
                        top = Dimen.largePadding,
                        leftRight = Dimen.extraLargePadding
                    )
            ){
                content(
                    state=state,
                    event=event,
                    windowSizeMode=windowSizeMode
                )
            }
        }
        else{
            Column(
                modifier =VerticalScrollBehavior
                    .toModifier()
                    .fillMaxWidth()
                    .weight(1f)
                    .showContentInOnePage()
                    .margin(
                        bottom = Dimen.normalPadding
                    )
                    .borderSetting()
                    .padding(
                        bottom =  Dimen.extraLargePadding,
                        top = Dimen.largePadding,
                        leftRight = Dimen.extraLargePadding
                    )
                ,
                horizontalAlignment =if (windowSizeMode== WindowSizeModeEnum.PHONE)
                    Alignment.CenterHorizontally else Alignment.Start
            ){

                content(
                    state=state,
                    event=event,
                    windowSizeMode=windowSizeMode
                )

            }
        }

    }



}

@Composable
private fun content(
    state: OptionsState,
    event: (OptionsEvent) -> Unit,
    windowSizeMode: WindowSizeModeEnum
) {
    DigitalCustomerCardInfo(
        info=state.virtualCardInfo,
        event = event,
        windowSizeMode = windowSizeMode,
    )

    if (windowSizeMode== WindowSizeModeEnum.PHONE){
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        )
        {
            GoogleWallet(
                info=state.virtualCardInfo,
                event = event,
                windowSizeMode = windowSizeMode,
            )

            AppleWallet(
                info=state.virtualCardInfo,
                event = event,
                windowSizeMode = windowSizeMode,
            )
        }

    }else{
        Row(
            Modifier.fillMaxWidth()
        )
        {
            GoogleWallet(
                info=state.virtualCardInfo,
                event = event,
                windowSizeMode = windowSizeMode,
            )

            AppleWallet(
                info=state.virtualCardInfo,
                event = event,
                windowSizeMode = windowSizeMode,
            )
        }
    }


}
